<template>
  <el-container class="parent">
    <el-aside width="350px" class="containerside">
      <div class="flex_between_nowrap">
        <span class="title_before side_title">资产模板</span>
        <el-button
          @click="add_role({})"
          type="text"
          class="then_color font14"
          icon="iconfont icon-add"
          >新增</el-button
        >
      </div>

      <div class="side_min">
        <!-- <el-input
        clearable
          placeholder="请输入内容"
          size="medium"
          class="input_icon"
          suffix-icon="el-icon-search inputIcon"
        ></el-input> -->
        <el-empty description="" v-if="!tempArr.length"></el-empty>
        <ul
          v-if="tempArr.length"
          style="  max-height: 710px;
  overflow-y: auto;"
          class="user_list"
        >
          <li
            v-for="(item, index) in tempArr"
            :class="index == current_index ? 'user_active' : ''"
            :key="index"
            @click="temp_click(item, index)"
          >
            <div>
              <i
                class="iconfont icon-user addColor"
                style="font-size:20px;line-height: 36px"
              ></i>
              <span style="line-height: 36px;height:36px">{{
                item.tName
              }}</span>
            </div>
            <div>
              <i
                @click.stop="add_role(item)"
                class="iconfont icon-xiugai then_color font16"
              ></i>
              <i
                class="el-icon-delete"
                @click.stop="
                  $axiosDelete('/pc/template/temp/del', { id: item.id },c_init,'',true)
                "
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </el-aside>
    <el-main class="min">
      <div style="margin-bottom:20px">
        <span class="title_before " style="padding-left:24px">自定义属性</span>
      </div>
      <div style="padding:0px 20px">
        <div class="flex_end" style="margin-bottom:30px">
          <!-- <el-input
          placeholder="请输入内容"
          size="small"
          v-model="params['search']"
          style="width:300px;margin-left:20px;"
        >
          <i slot="suffix" class="el-icon-search inputIcon " ></i>
        </el-input> -->
          <el-button type="submit" @click="add_form({})">新增</el-button>
        </div>
        <x-table url="/pc/template/form/page"  :params="params" ref="xTable">
          <el-table-column
            v-for="(item, index) in columnArr"
            :key="index"
            :label="item.label"
            :prop="item.model"
            ><template slot-scope="scope">
              <span v-if="item.model == 'formLabel'">{{
                formLabel_Type(scope.row[item.model])
              }}</span>

              <span v-else-if="item.model == 'whetherRequired'">{{
                scope.row[item.model] == true ? "是" : "否"
              }}</span>
              <el-switch
                   @change="switchChange(scope.row[item.model], scope.row.id)"
                v-else-if="item.model == 'status'"
                v-model="scope.row[item.model]"
              >
              </el-switch>
              <span v-else>{{ scope.row[item.model] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="addColor"
                @click="add_form(scope.row)"
                >编辑</el-button
              >
              <el-button type="text"    @click.stop="
                    $axiosDelete(
                      '/pc/template/form/del',
                      { id: scope.row.id },
                      tableSearch,
                      '',true
                    
                    )
                  " class="deleteColor">删除</el-button>
            </template>
          </el-table-column>
        </x-table>
        <!-- <div class="flex_between_nowrap" style="margin-bottom:30px"></div> -->
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      params: {},
      current_index: null,
      tempArr: [],
      columnArr: [
        {
          label: "名称",
          model: "formTitle",
        },
        {
          label: "类型",
          model: "formLabel",
        },
        {
          label: "是否必填",
          model: "whetherRequired",
        },

        {
          label: "启用/停用",
          model: "status",
        },
      ],
    };
  },
  created() {
  },
  methods: {
     switchChange(data, id) {
      this.$alertMsg.confirm(
        `确定进行${data ? "启用" : "停用"}吗`,
        () => {
          this.$requestAxios(
            {
              url: "/pc/template/form/stop",
              data: { id },
            },
            (data) => {
              this.$success()
               this.tableSearch();
            }
          );
         
        },
        () => {
          this.tableSearch();
        }
      );
    },
    formLabel_Type(data) {
      let a = "";
      switch (data) {
        case "text":
          a = "文本";
          break;
        case "select":
          a = "多选";
          break;
        case "time":
          a = "时间";
          break;
      }
      return a;
    },
    temp_click(item, index) {
      this.params.id = item.id;
      this.current_index = index;
      this.tableSearch();
    },
    tableSearch() {
      setTimeout(() => {
        this.$refs.xTable.search();
      });
    },
    add_form(item) {
      this.$createDialog(this, {
        dialogConfig: {
          title: item.id ? "自定义编辑" : "自定义新增",
          width: "360px",
        },
        namespace: "sys_add_form",
        whetherDestruction: true,

        assemblyConfig: {
          row: item,
          templateId: this.params.id,
          callBack: this.tableSearch,
        },
      });
    },
    add_role(item) {
      this.$createDialog(this, {
        dialogConfig: {
          title: item.id ? "模板编辑" : "模板新增",
          width: "360px",
        },
        namespace: "sys_add_temp",
        whetherDestruction: true,

        assemblyConfig: {
          row: item,
          callBack: this.c_init,
        },
      });
    },

    c_init() {
      /*left模板列表  */
      this.$requestAxios(
        {
          url: "/pc/template/temp/page",
          data: { size: 9999 },
        },
        (data) => {
          this.tempArr = data.data;
          if (this.tempArr.length) {
            this.temp_click(this.tempArr[0], 0);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
ul,
li {
  padding: 0;
  margin: 0;
}
.firstul {
}
.firstul > li {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 43px;
  padding-top: 55px;
}
.firstul > li:first-child {
  padding-top: 20px;
}
.min_foo {
  position: fixed;
  bottom: 22px;
  right: 40px;
  width: 100%;
}
.min_foo > div {
  height: 80px;
}
.childrenul {
  display: flex;
  flex-flow: row wrap;
  margin-left: 28px;
}
.childrenul > li {
  margin-right: 40px;
  margin-top: 20px;
}
.parent {
  height: 100%;
  background-color: #f6f7fc;
}

.side_min {
  padding-left: 20px;
  margin-top: 20px;
  height: 100%;
}
.input_icon {
  margin-bottom: 30px;
}


.user_list,
.user_list li {
  margin: 0;
  padding: 0;
}
.user_list li {
  padding-left: 22px;
  padding-right: 10px;
  background-color: #fff;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.user_list li > div:last-child {
  display: none;
}
.user_list li > div:first-child > span {
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
  color: #333333;
  line-height: 36px;
}
.user_list li:hover {
  background-color: #f3f6fb;
  border-radius: 2px;
}
.user_list li > div:last-child > i:last-child {
  margin-left: 10px;
  opacity: 0.8;
}

.user_list li:hover > div:last-child {
  display: block;
}

.user_active {
  background-color: #f3f6fb !important;
  border-radius: 2px;
}
.user_active > div:last-child {
  display: block !important;
}

.iconList > i {
  padding-right: 10px;
}
</style>
